import { LoadingFile } from '@components/SiteUserUpload/Components/Steps/components/LoadingFile';

export const FileFinalizeView = () => {
  return (
    <LoadingFile
      text={'File Processing'}
      currentSubStep={2}
      subTitle={
        'File has been successfully uploaded and is being validated. \nIt may take several minutes before you can see the validation results.'
      }
    />
  );
};

type FileFinalizeErrorViewProps = {
  handleTryAgain: () => void;
};

export const FileFinalizeErrorView = ({
  handleTryAgain,
}: FileFinalizeErrorViewProps) => {
  return (
    <LoadingFile
      text={'File Processing Failed'}
      currentSubStep={2}
      subTitle={
        'File processing failed. The file you was uploading was not saved. \nPlease try again later or contact support for assistance.'
      }
      tryAgainButton
      tryAgainFunc={handleTryAgain}
      spinnerType={'Semicircle'}
    />
  );
};
